// "Solutions by institution" landing pages (/solutions/:solutionId).
// Each page targets how that audience searches, e.g. "school website design",
// "coaching institute marketing", "play school website", "library management software".
// TODO: review copy and FAQ answers with the team.

export const solutions = [
  {
    id: 'schools',
    icon: 'book',
    name: 'Schools',
    noun: 'school',
    short: 'Websites, ERP, admissions marketing and smart classrooms for K-12 schools.',
    metaTitle: 'Digital Solutions for Schools: Website, ERP & Admission Marketing',
    metaDescription: 'School website design, school ERP software, admission marketing, social media and smart classroom setup for schools in Delhi NCR and across India.',
    headline: 'Everything your school needs online, handled by one team.',
    intro: 'From a website parents trust to an ERP that runs fees and attendance, Fedigma helps K-12 schools in Delhi NCR and across India go digital, without juggling five different vendors.',
    challenges: [
      'Admission enquiries still depend mostly on word of mouth',
      'Fees, attendance and results live in registers and spreadsheets',
      'The website, Google listing and social media are outdated',
      'Classrooms need a smart-class upgrade but vendors are confusing'
    ],
    services: [
      { id: 'web-development', text: 'A school website with admissions, notices, results, galleries and fee information parents can find easily.' },
      { id: 'school-management', text: 'EdTrack Smart runs admissions, attendance, fees, exams and report cards, with a parent app.' },
      { id: 'digital-marketing', text: 'Admission season campaigns on Google and Instagram that bring genuine parent enquiries.' },
      { id: 'online-presence', text: 'An active Instagram, Facebook and Google profile, with more and better reviews.' },
      { id: 'digital-classroom', text: 'Interactive panels and smart boards sourced and installed through trusted vendors.' },
      { id: 'creative-services', text: 'Prospectus, event videos, result posters and annual day highlights.' }
    ],
    showProduct: true,
    relatedWork: ['EdTrack Smart', 'Advance Forte', 'EduMerit Institute'],
    faqs: [
      { question: 'What should a school website include?', answer: 'At minimum: admissions information and an enquiry form, fee structure, academics, facilities, faculty, notices and circulars, results and achievements, a photo gallery, and clear contact details with a map.' },
      { question: 'Can the ERP and website work together?', answer: 'Yes. Admission enquiries from your website can flow into EdTrack Smart, and parents can log in to see attendance, fees and results.' },
      { question: 'When should a school start admission marketing?', answer: 'Ideally 6–8 weeks before your admission window opens, so your website, Google listing and ads are ready before parents start searching.' }
    ]
  },
  {
    id: 'coaching-institutes',
    icon: 'award',
    name: 'Coaching Institutes',
    noun: 'coaching institute',
    short: 'More students for JEE, NEET, banking, SSC and foundation batches.',
    metaTitle: 'Website & Digital Marketing for Coaching Institutes',
    metaDescription: 'Websites, mock-test apps, lead generation and social media for coaching institutes preparing students for JEE, NEET, banking, SSC and government exams.',
    headline: 'Fill every batch with the right students.',
    intro: 'Students compare coaching institutes online before they ever visit. We build the website, content and campaigns that make yours the obvious choice, as we have for Advance Forte, EduMerit and IBS Bank Career.',
    challenges: [
      'Competitors rank above you for "best coaching near me"',
      'Enquiries come in but are not followed up quickly',
      'Results and toppers are not showcased online',
      'Students expect mock tests and study material on their phones'
    ],
    services: [
      { id: 'web-development', text: 'A course-led website with batches, fees, faculty, results, demo bookings and callback requests.' },
      { id: 'digital-marketing', text: 'Lead campaigns for new batches, with enquiries routed to your counsellors on WhatsApp.' },
      { id: 'online-presence', text: 'Toppers, results, tips and reels that build trust on Instagram, YouTube and Google.' },
      { id: 'mobile-app', text: 'An app for lectures, PDFs, mock tests, results and rank lists.' },
      { id: 'content-writing', text: 'Question banks, DPPs, notes and exam-guide blogs that bring students to your site.' },
      { id: 'school-management', text: 'EdTrack Smart for batches, attendance, fees, tests and rank lists across centres.' }
    ],
    showProduct: true,
    relatedWork: ['Advance Forte', 'EduMerit Institute', 'IBS Bank Career'],
    faqs: [
      { question: 'How can a coaching institute get more students online?', answer: 'Combine a fast website with clear course pages, a strong Google Business Profile with reviews, regular result and topper posts, and targeted ads before each new batch.' },
      { question: 'Do you build mock test platforms?', answer: 'Yes. We build websites and apps with mock tests, results and rank lists, and EdTrack Smart includes an online test and DPP module.' },
      { question: 'Which exams do you have experience with?', answer: 'Our coaching clients prepare students for IIT-JEE, NEET, foundation classes, banking exams such as JAIIB, CAIIB, IBPS and SBI, and SSC.' }
    ]
  },
  {
    id: 'kindergartens',
    icon: 'smile',
    name: 'Kindergartens & Play Schools',
    noun: 'play school',
    short: 'A warm, trustworthy online presence that parents love.',
    metaTitle: 'Website & Social Media for Kindergartens and Play Schools',
    metaDescription: 'Play school and kindergarten websites, Instagram management, Google reviews and admission campaigns that help parents choose you with confidence.',
    headline: 'Help parents choose your play school with confidence.',
    intro: 'For parents of young children, trust is everything. We help kindergartens and play schools show their care, safety and activities online, and we already manage digital presence for several kindergartens.',
    challenges: [
      'Parents can’t see what a day at your school looks like',
      'Few Google reviews compared to nearby play schools',
      'No time to post activities and events regularly',
      'Admission enquiries peak for only a few months a year'
    ],
    services: [
      { id: 'online-presence', text: 'Regular posts of activities, celebrations and learning moments, plus more parent reviews.' },
      { id: 'web-development', text: 'A bright, simple website with programmes, safety, facilities, a gallery and a visit-booking form.' },
      { id: 'creative-services', text: 'Event videos, festival posters, certificates and admission flyers.' },
      { id: 'digital-marketing', text: 'Local campaigns that reach parents of young children in your area.' },
      { id: 'school-management', text: 'Simple fee, attendance and parent communication through EdTrack Smart.' }
    ],
    showProduct: false,
    relatedWork: [],
    faqs: [
      { question: 'Does a small play school really need a website?', answer: 'Yes. Most parents search on Google and check reviews and photos before visiting. A simple website and an active Google profile make you look established and trustworthy.' },
      { question: 'How often should a play school post on social media?', answer: 'Three to four posts a week works well: activities, celebrations, learning moments and admission updates.' },
      { question: 'Can you share photos of children safely?', answer: 'We follow your school’s photo policy and parent consent, and can blur or avoid children’s faces where required.' }
    ]
  },
  {
    id: 'colleges',
    icon: 'layers',
    name: 'Colleges & Universities',
    noun: 'college',
    short: 'Admissions, campus ERP, content and career guidance at scale.',
    metaTitle: 'Digital Solutions for Colleges: Website, ERP & Admissions',
    metaDescription: 'College websites, campus ERP, admission campaigns, academic content and career counselling for colleges and universities in India.',
    headline: 'A modern digital campus, from admissions to placements.',
    intro: 'Colleges juggle admissions, departments, exams and student services. We bring the website, ERP, marketing and content together so your campus runs smoothly and attracts the right students.',
    challenges: [
      'Course information is scattered and hard to find online',
      'Semester, department and exam records are managed manually',
      'Admission campaigns lack tracking and follow-up',
      'Students need better guidance on careers and further study'
    ],
    services: [
      { id: 'web-development', text: 'A clear college website with programmes, departments, faculty, admissions, notices and events.' },
      { id: 'school-management', text: 'EdTrack Smart for semester enrollment, departments, faculty allocation and exam records.' },
      { id: 'digital-marketing', text: 'Programme-wise admission campaigns with landing pages and lead tracking.' },
      { id: 'career-counselling', text: 'Career awareness workshops and one-to-one guidance for students.' },
      { id: 'content-writing', text: 'Prospectus, programme pages, newsletters and academic content.' },
      { id: 'digital-classroom', text: 'Smart seminar halls and lecture recording, set up through trusted vendors.' }
    ],
    showProduct: true,
    relatedWork: ['EdTrack Smart', 'IBS Bank Career'],
    faqs: [
      { question: 'Can EdTrack Smart handle multiple departments?', answer: 'Yes. It supports semester-wise enrollment, departments, faculty allocation and examination records across campuses.' },
      { question: 'Do you run career workshops in colleges?', answer: 'Yes. We run career awareness sessions and offer one-to-one counselling for students exploring jobs and further study.' },
      { question: 'Can you redesign our existing college website?', answer: 'Yes. We restructure content so programmes and admissions are easy to find, and keep your search rankings intact.' }
    ]
  },
  {
    id: 'libraries',
    icon: 'library',
    name: 'Libraries & Study Centres',
    noun: 'library',
    short: 'Memberships, seat booking, reminders and an online presence for libraries.',
    metaTitle: 'Library Management Software & Website for Libraries',
    metaDescription: 'Library management with memberships, book issue and return, seat booking and due-date reminders, plus websites and promotion for public, institute and self-study libraries.',
    headline: 'Run your library smoothly and fill every seat.',
    intro: 'Whether you run a public library, an institute library or a self-study reading room, we help you manage members and seats digitally and attract more students online.',
    challenges: [
      'Memberships, seats and fees are tracked on paper',
      'Members queue up just to check if a book is available',
      'Due-date reminders are sent manually, or not at all',
      'Students in your area don’t know your study centre exists'
    ],
    services: [
      { id: 'school-management', text: 'EdTrack Smart tracks memberships, book issue and return, seat bookings and automatic reminders.' },
      { id: 'web-development', text: 'A website with facilities, timings, plans and online seat enquiries.' },
      { id: 'online-presence', text: 'A strong Google listing and reviews so students nearby can find you.' },
      { id: 'digital-marketing', text: 'Local campaigns that reach students preparing for exams near you.' },
      { id: 'mobile-app', text: 'An app for members to check availability, book seats and renew plans.' }
    ],
    showProduct: true,
    relatedWork: ['EdTrack Smart'],
    faqs: [
      { question: 'Can EdTrack Smart manage seat bookings for a study centre?', answer: 'Yes. It tracks memberships, seat bookings, book issue and return, and sends due-date reminders automatically.' },
      { question: 'How do students find self-study libraries?', answer: 'Mostly through Google Maps searches like "library near me" or "study centre near me", so a complete Google Business Profile with photos and reviews is essential.' },
      { question: 'Do you work with public and institute libraries too?', answer: 'Yes. We work with public libraries, institute libraries and private self-study centres.' }
    ]
  }
];

export const getSolution = (id) => solutions.find((solution) => solution.id === id);
